/* eslint no-eval: 0 */

/**
 * @exports {Function} noop
 * @file
 * A global no-op function. Instead of creating a no-op function in your
 * local file or app, just require this module. This is more performant
 * when it comes to memory management, as you don't need to create a new
 * function each time. There's just one noop on the global namespace.
 */

const get = eval;
const global = get("this") || {};

if (!global.noop) {
	global.noop = function noop() {};
}

export default global.noop;



// WEBPACK FOOTER //
// ./src/shared/util/noop.js